import { useCallback } from 'react';
import useHandleAppException from './useHandleAppException';

export default function useHandleApiError() {
  const { handleError } = useHandleAppException();

  const isAppException = (response: any): boolean =>
    (response.data && response.data.code && response.data.message) ||
    (response.code && response.message);

  const getApiErrorMessage = useCallback(
    <T = any>(response: any, defaultMessage?: string): string => {
      const message = response.data?.message || response.message;

      if (isAppException(response)) {
        return handleError<T>({
          code: response.data?.code || response.code,
          message,
          data: response.data?.data,
        });
      }

      if (message) {
        if (Array.isArray(message)) {
          return message.join(', ');
        }
        return message;
      }

      return defaultMessage || 'ocorreu um erro!';
    },
    [handleError],
  );

  return { getApiErrorMessage };
}
